import { Grid, Paper } from '@material-ui/core';
import { Button, ExtendedTheme, Heading, TextBlock } from 'neon-design-system';
import { baseUrls } from '../../constants/urls';
import { useHistory } from 'react-router-dom';
import { createStyles, makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme: ExtendedTheme) =>
  createStyles({
    noRequestsPaper: {
      padding: theme.spacing(2)
    }
  })
);

export const NoRequestsTile = () => {
  const { push } = useHistory();
  const classes = useStyles();

  return (
    <Paper className={classes.noRequestsPaper}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Heading styleName="title1">No requests</Heading>
            </Grid>
            <Grid item xs={12}>
              <TextBlock styleName="footnote">You currently have no requests to monitor.</TextBlock>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Button colorType="grey" onClick={() => push(baseUrls.home)}>
            Back to Support Center
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};
